import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    height: 32px;\n    width: 32px;\n    cursor: pointer;\n\n    &:hover,\n    &:focus,\n    &:active {\n        ", "\n    }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: flex-end;\n    margin-top: -", "px;\n    margin-right: -", "px;\n\n    ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: flex-end;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n\n    ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    background: white;\n    display: flex;\n    height: 100vh;\n    overflow: hidden;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: inherit;\n\n    ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        ", ";\n        width: ", ";\n        transition: ", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { getPropsBlocker } from '../../utils';
import { transitionDurationInSec } from '../../constants';
import { minWidth, widthWide, widthDefault, closeIconOffset } from './constants';
import { getComponentOverride } from '../../system/mixins/getComponentOverride';
import { reset, zIndex } from '../../system';
var propertyList = {
  effectToggle: true,
  disableEffects: true,
  zIndex: true
};

var calculateWidth = function calculateWidth(effectToggle, wide) {
  if (effectToggle) {
    return wide ? "max(".concat(widthWide, ", ").concat(minWidth, ");") : "max(".concat(widthDefault, ", ").concat(minWidth, ");");
  }

  return '0';
};

var getWindowStyle = function getWindowStyle(_ref) {
  var disableEffects = _ref.disableEffects,
      effectToggle = _ref.effectToggle,
      SideSheet = _ref.theme.componentOverrides.SideSheet,
      wide = _ref.wide;
  return css(_templateObject(), SideSheet.Root.base, calculateWidth(effectToggle, wide), disableEffects ? 'none' : "width ".concat(transitionDurationInSec, "s ease"));
};

var contentStyle = function contentStyle(_ref2) {
  var SideSheet = _ref2.theme.componentOverrides.SideSheet;
  return SideSheet.Content.base;
};

var closeIconContainerStyle = function closeIconContainerStyle(_ref3) {
  var SideSheet = _ref3.theme.componentOverrides.SideSheet;
  return SideSheet.Icon.base;
};

var closeIconStyle = function closeIconStyle(_ref4) {
  var SideSheet = _ref4.theme.componentOverrides.SideSheet;
  return SideSheet.Icon.focused;
};

export var SideSheetRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject2(), reset, zIndex, getComponentOverride('SideSheet'));
export var SideSheetWindow = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject3(), getWindowStyle);
export var SideSheetContent = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject4(), contentStyle);
export var SideSheetHeaderContainer = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject5());
export var SideSheetHeaderCloseButtonContainer = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject6(), closeIconOffset, closeIconOffset, closeIconContainerStyle);
export var SideSheetHeaderCloseButtonContent = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject7(), closeIconStyle);
export var iconStyle = {
  outline: 'none',
  margin: "".concat(closeIconOffset, "px")
};